import type { AssistantMessageDto } from '../generated/dtos.gen';

export interface AssistantMessagePart {
  type: string;
  [key: string]: unknown;
}

export type AssistantThreadMessage = Omit<AssistantMessageDto, 'parts'> & { parts: AssistantMessagePart[] };

const isPart = (value: unknown): value is AssistantMessagePart =>
  typeof value === 'object' && value !== null && 'type' in value && typeof value.type === 'string';

export const readMessageParts = (parts: unknown): AssistantMessagePart[] => (Array.isArray(parts) ? parts.filter(isPart) : []);

export const readThreadMessage = (message: AssistantMessageDto): AssistantThreadMessage => ({ ...message, parts: readMessageParts(message.parts) });
